import { create } from "zustand";

/**
 * Whether a product page's sticky buy bar is on screen, per breakpoint. The
 * floating chat and accessibility buttons read it and move up, so they never
 * sit on top of ADD TO CART.
 */
interface StickyBuyBarStore {
  mobile: boolean;
  desktop: boolean;
  set: (which: "mobile" | "desktop", visible: boolean) => void;
}

export const useStickyBuyBar = create<StickyBuyBarStore>()((set) => ({
  mobile: false,
  desktop: false,
  set: (which, visible) => set({ [which]: visible } as Pick<StickyBuyBarStore, "mobile" | "desktop">),
}));
